import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Box, Text } from 'rebass';

import { FT_COLORS } from '../theme';

// A bordered, rounded row matching the family-member rows. Used for the
// "Upload" / "Record" affordances and the filled thumbnail state (Photo & Video).
const MediaRow = ({ icon, leading, label, sublabel, isUploading, onClick, trailing, ...props }) => (
  <Flex
    as={onClick ? 'button' : 'div'}
    type={onClick ? 'button' : undefined}
    alignItems="center"
    width="100%"
    bg="white"
    p={2}
    mb={2}
    onClick={onClick}
    sx={{
      border: '1px solid',
      borderColor: FT_COLORS.rowBorder,
      borderRadius: '12px',
      cursor: onClick ? 'pointer' : 'default',
      gap: '10px',
      textAlign: 'left',
    }}
    {...props}
  >
    {leading || (icon && <Box as={icon} size={18} color={FT_COLORS.primary} css="flex: 0 0 auto;" />)}
    {isUploading ? <Box mr="auto" css="min-width: 0;"> <Text
      fontFamily="Poppins"
      fontSize="14px"
      fontWeight={500}
      color={'#64748B'}
      css="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;font-style: italic;"
    >
      Uploading video...
    </Text>
    </Box> : <Box mr="auto" css="min-width: 0;">
      <Text
        fontFamily="Poppins"
        fontSize="16px"
        fontWeight={500}
        color={FT_COLORS.text}
        css="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
      >
        {label}
      </Text>
      {sublabel && (
        <Text fontFamily="Poppins" fontSize="12px" color={FT_COLORS.muted}>
          {sublabel}
        </Text>
      )}
    </Box>}
    {trailing}
  </Flex>
);

MediaRow.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  leading: PropTypes.node,
  label: PropTypes.string.isRequired,
  sublabel: PropTypes.string,
  onClick: PropTypes.func,
  trailing: PropTypes.node,
};

MediaRow.defaultProps = {
  icon: null,
  leading: null,
  sublabel: null,
  onClick: null,
  trailing: null,
};

export default MediaRow;
